import { jsx as _jsx } from "react/jsx-runtime";
import UIPaginator from 'UIComponents/paginator/UIPaginator';
import { useQueryParam } from '../../../utils/hooks';
import { useDirectoryUsers } from '../directoryQueries';

const noop = () => {};

const DirectoryPaginator = ({
  onPageChange = noop
}) => {
  const {
    totalPages,
    pageNumber
  } = useDirectoryUsers();
  const [, setPage] = useQueryParam('page');

  const handlePageChange = ({
    target: {
      value
    }
  }) => {
    onPageChange(parseInt(value, 10));
    setPage(value);
  };

  if (totalPages === 0) return null;
  return /*#__PURE__*/_jsx(UIPaginator, {
    className: "m-top-6",
    pageCount: totalPages,
    page: pageNumber,
    onPageChange: handlePageChange
  });
};

export default DirectoryPaginator;